"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTagsInputWrapper = exports.StyledDropdownRefWrapper = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../themes");
exports.StyledDropdownRefWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nposition: relative;\n    user-select: none;\n"], ["\nposition: relative;\n    user-select: none;\n"])));
exports.StyledTagsInputWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  height: 100%;\n  gap: 1rem;\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  height: 100%;\n  gap: 1rem;\n  ", "\n"])), function (_a) {
    var input_display = _a.input_display;
    return input_display === 'input'
        ? (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    max-width: calc(100vw - 10rem); //2+2 for page container padding on mob & 2+4 for the select elem padding\n    "], ["\n    background-color: ", ";\n    max-width: calc(100vw - 10rem); //2+2 for page container padding on mob & 2+4 for the select elem padding\n    "])), themes_1.colors.white) : (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n    "], ["\n\n    "])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
